import React from "react";
import {Helmet} from "react-helmet";

export function Head() {

	return (
        <div>
            <Helmet>
                <meta charset="utf-8"/>
			    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
			    <meta name="keywords" content=""/>
			    <meta name="description" content="ESG 420 NFT Drop"/>
			    <meta name="author" content="East Side Games"/>
			    <meta property="fb:app_id"          content="1234567890" />
			    <meta property="og:type"            content="article" /> 
			    <meta property="og:url"             content="#" /> 
			    <meta property="og:title"           content="ESG 420 NFT Drop" /> 
			    <meta property="og:image"           content="img/esg-sig.png" />
			    <title>ESG 420 NFT Drop</title>
			    <link rel='shortcut icon' href='favicon.ico' type='image/x-icon' />
			    <link rel="stylesheet" href="css/style.css?v=1"/>
				<link href="https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap" rel="stylesheet"/>
            </Helmet>
        </div>
	)

};